<template>
    <v-sheet>
        <dashboard-head />
        <dashboard-body class="mt-40 mt-lg-100" />
    </v-sheet>
</template>

<script>
import DashboardBody from "./dashboard/dashboard-body.vue";
import DashboardHead from "./dashboard/dashboard-head.vue";

export default {
    components: {
        DashboardBody,
        DashboardHead,
    },
};
</script>

<style></style>
